/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="76" height="78" viewBox="0 0 76 78" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
    <title>Shield With Clock</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="Client-Bene-LP" transform="translate(-682.000000, -162.000000)" stroke-width="2.5">
            <g id="Group" transform="translate(653.000000, 139.000000)">
                <g id="Group-11" transform="translate(30.690323, 24.400000)">
                    <path d="M45.2621742,69.37224 C41.8922903,71.32344 38.0019677,73.06824 33.5125355,74.56024 C3.39798065,64.54904 0.219154839,43.18504 0.21656129,23.95704 L0.21656129,11.80664 C13.6814,11.43464 24.4714258,7.70184 33.5125355,0.20024 C42.5545097,7.70184 53.3454,11.43464 66.8102387,11.80664 L66.8102387,23.95704 C66.8102387,24.91944 66.8050516,25.89144 66.7523161,27.66984" id="Stroke-1" stroke="#FFFFFF"/>
                    <path d="M56.3885832,29.91832 C66.7627768,31.41192 73.8898477,40.43832 72.2749316,50.03832 C70.66088,59.63832 60.9065445,66.23432 50.532351,64.73912 C40.1572929,63.24552 33.0302219,54.21912 34.6451381,44.61912 C35.9514219,36.84952 42.5900413,31.04792 50.5738477,29.91032" id="Stroke-3" stroke="#FFFFFF"/>
                    <line x1="44.8627677" y1="27.74568" x2="50.5573355" y2="29.94168" id="Stroke-5" stroke="#FFFFFF"/>
                    <line x1="50.5522348" y1="29.94568" x2="46.8391381" y2="34.61608" id="Stroke-7" stroke="#FFFFFF"/>
                    <polyline id="Stroke-9" stroke="#FCB61C" points="65.5149342 46.748 53.2880826 46.748 53.2880826 35.6064"/>
                </g>
            </g>
        </g>
    </g>
</svg>
    )
  }
}

Icon.displayName = 'ShieldWithClockIcon'

export default Icon
